import { ChakraProvider } from "@chakra-ui/react";
import { useEffect } from "react";
import { useRouter } from "next/router";

import AuthWrapper from "@/components/AuthWrapper";
import ProfileGate from "@/components/ProfileGate";
import { UserProvider, useUser } from "@/context/UserContext";
import { ProfileProvider } from "@/context/ProfileContext";
import { LayoutProvider } from "../context/LayoutContext";
import Layout from "../components/Layout";
import theme from "@/theme";
import "../styles/fonts.css";

function AnalyticsTracker() {
  const { user } = useUser();
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => {};
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events, user]);

  return null;
}

function MyApp({ Component, pageProps }) {
  const useLayout = Component.noLayout !== true;

  return (
    <ChakraProvider theme={theme}>
      <UserProvider>
        <ProfileProvider>
          <AnalyticsTracker />
          <AuthWrapper>
            <LayoutProvider>
              <ProfileGate>
                {useLayout ? (
                  <Layout>
                    <Component {...pageProps} />
                  </Layout>
                ) : (
                  <Component {...pageProps} />
                )}
              </ProfileGate>
            </LayoutProvider>
          </AuthWrapper>
        </ProfileProvider>
      </UserProvider>
    </ChakraProvider>
  );
}

export default MyApp;
